/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";

import { StyleProps } from "../../types/types";
import LinkButton from "./linkButton";

export type ButtonProps = {
  internallink: string;
  externallink: string;
  label: string;
  template: string;
  variant: string;
  openInNewTab?: boolean;
} & StyleProps;
export const Button: React.FC<ButtonProps> = (props) => {
  return <LinkButton {...props} />;
};

export default Button;
